import type { LocaleProxy } from './types'
import { isHTMLInputElement } from './predicates'
import { onNextPageTeardown } from './page-teardown'

let locale = ''

const clearUserLocale = (): void => {
  locale = ''
}

// On each navigation we have to reset and thus recheck the locale as it might have changed since the previous route
const handleRoutechange = (): void => {
  onNextPageTeardown(clearUserLocale)
}

const getUserLocale = (): string => {
  const localeElement = document.getElementById('current_user_locale')

  if (isHTMLInputElement(localeElement)) {
    return localeElement.value
  } else {
    return 'en'
  }
}

const setupUserLocale = (): void => {
  locale = getUserLocale()

  handleRoutechange()
}

const localeProxy: LocaleProxy = new Proxy(
  { value: locale },
  {
    get(target, property, receiver): typeof receiver.property {
      if (property === 'value') {
        if (locale === '') {
          setupUserLocale()
        }

        return locale
      }

      return Reflect.get(target, property, receiver)
    },
  }
)

export default localeProxy
